import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';

export type NetworkStatus = {
  connected: boolean;
  connectionType: string;
};

export async function getNetworkStatus(): Promise<NetworkStatus> {
  if (!Capacitor.isNativePlatform() && typeof navigator !== 'undefined') {
    return {
      connected: navigator.onLine,
      connectionType: navigator.onLine ? 'unknown' : 'none',
    };
  }
  try {
    const status = await Network.getStatus();
    return {
      connected: status.connected,
      connectionType: status.connectionType,
    };
  } catch {
    return {
      connected: typeof navigator !== 'undefined' ? navigator.onLine : true,
      connectionType: 'unknown',
    };
  }
}

export function addNetworkListener(
  callback: (status: NetworkStatus) => void,
): () => void {
  let removed = false;
  let handle: { remove: () => Promise<void> } | null = null;

  void Network.addListener('networkStatusChange', (status) => {
    if (removed) return;
    callback({
      connected: status.connected,
      connectionType: status.connectionType,
    });
  }).then((h) => {
    handle = h;
    if (removed) void h.remove();
  });

  const onOnline = () => callback({ connected: true, connectionType: 'unknown' });
  const onOffline = () => callback({ connected: false, connectionType: 'none' });

  if (typeof window !== 'undefined') {
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
  }

  return () => {
    removed = true;
    void handle?.remove();
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    }
  };
}
